<div class="analytics-container" *ngIf="projectId && project">
  <div class="page-title">project analytics</div>

  <ng-container *ngIf="project.urls?.powerbi">
    <iframe title="Domain data visulization - OverView" width="100%" height="600px"
            [src]="sanitizer.bypassSecurityTrustResourceUrl(project.urls.powerbi)" frameborder="0"
            allowFullScreen="true"></iframe>
  </ng-container>

  <ng-container *ngIf="!project.urls?.powerbi">
    <div class="project-info">
      <div style="display: flex; align-items: center">
        <img *ngIf="project.logo && project.logo.fileName"
             [src]="SERVER_URL + 'images/' + project.projectCode + '/images/' + project.logo.fileName">
        <img *ngIf="!(project.logo && project.logo.fileName)" src="assets/images/default-project-logo.jpg">
        <div>
          <h4>{{project.name}}</h4>
          <div class="address">{{project.addressLine2}}
            , {{project.area}} {{project.state}} {{project.postCode}}</div>
        </div>
      </div>
      <div fxLayout="row" fxLayoutGap="50px" style="color: #dedede">
        <div *ngIf="project.totalUnit" class="text-center">
          <div>Total Units</div>
          <div>{{project.totalUnit}}</div>
        </div>
        <div class="text-center">
          <div>Available</div>
          <div>{{availableNum}}</div>
        </div>
        <div class="text-center">
          <div>Reserved</div>
          <div>{{reserveNum}}</div>
        </div>
        <div class="text-center">
          <div>Sold</div>
          <div>{{soldNum}}</div>
        </div>
      </div>
    </div>

    <ng-container *ngIf="currentUserId === 'dev-admin@aus-pac.com'">
      <div style="margin-top: 20px" fxLayout="column" fxLayoutGap="20px">
        <div fxLayout="row" fxLayoutGap="20px">
          <div fxFlex="50" style="background: #fff">
            <app-timeline [projectId]="projectId"></app-timeline>
          </div>
          <div fxFlex="50" style="background: #fff">
            <app-year-trend [projectId]="projectId"></app-year-trend>
          </div>
        </div>
        <div fxLayout="row" fxLayoutGap="20px">
          <div fxFlex="50" style="background: #fff">
            <app-property-type [projectId]="projectId"></app-property-type>
          </div>
          <div fxFlex="50" style="background: #fff">
            <app-buyer-segmentation [projectId]="projectId"></app-buyer-segmentation>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- the real one-->
    <div class="project" *ngIf="currentUserId !== 'dev-admin@aus-pac.com'">
      <div>
        <div fxLayout="row" fxLayoutGap="20px">
          <app-property-type [projectId]="project.id" fxFlex="30"></app-property-type>
          <app-timeline [projectId]="project.id" fxFlex="35"></app-timeline>
          <app-year-trend [projectId]="project.id" fxFlex="35"></app-year-trend>
        </div>
        <div fxLayout="row" fxLayoutGap="20px">
          <app-buyer-segmentation [projectId]="project.id" fxFlex="30"></app-buyer-segmentation>
          <div fxLayout="column" fxLayoutAlign="center" fxLayoutGap="10px" fxFlex="60"
               *ngIf="project.demography">
            <div fxLayout="row" fxLayoutGap="10px">
              <div fxFlex="33" class="region-item">
                <div class="value"> {{project.demography.population ? project.demography.population :
                  '-'}} </div>
                <div class="title">total population in {{project.area}}</div>
              </div>
              <div fxFlex="33" class="region-item">
                <div class="value"> {{project.demography.median_age}}</div>
                <div class="title">median age of {{project.area}}</div>
              </div>
              <div fxFlex="33" class="region-item">
                <div class="value">
                  <ng-container *ngIf="project.demography.median_weekly_household_income != 0">
                    {{project.demography.median_weekly_household_income | currency:
                    '':'symbol':'3.0'}}
                  </ng-container>
                  <ng-container *ngIf="project.demography.median_weekly_household_income == 0">
                    -
                  </ng-container>
                </div>
                <div class="title">median weekly household income</div>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="10px">
              <div fxFlex="33" class="region-item">
                <div class="value">
                  <ng-container *ngIf="owner && rented">
                    <ng-container *ngIf="owner >= rented">
                      {{rentRatio}} : 1
                    </ng-container>
                    <ng-container *ngIf="owner < rented">
                      1 : {{rentRatio}}
                    </ng-container>
                  </ng-container>
                  <ng-container *ngIf="!owner || !rented">
                    -
                  </ng-container>
                </div>
                <div class="title">
                  <ng-container *ngIf="owner && rented">
                    <ng-container *ngIf="owner >= rented">
                      Owner : Renter
                    </ng-container>
                    <ng-container *ngIf="owner < rented">
                      Renter : Owner
                    </ng-container>
                  </ng-container>
                  <ng-container *ngIf="!owner || !rented">
                    Owner : Renter
                  </ng-container>
                </div>
              </div>
              <div fxFlex="33" class="region-item">
                <div class="value">
                  <ng-container *ngIf="employed && unemployed">
                    <ng-container *ngIf="employed >= unemployed">
                      {{employRatio}} : 1
                    </ng-container>
                    <ng-container *ngIf="employed < unemployed">
                      1 : {{employRatio}}
                    </ng-container>
                  </ng-container>
                  <ng-container *ngIf="!employed || !unemployed">
                    -
                  </ng-container>
                </div>
                <div class="title">
                  <ng-container *ngIf="employed && unemployed">
                    <ng-container *ngIf="employed >=unemployed">
                      Employed : Unemployed
                    </ng-container>
                    <ng-container *ngIf="employed < unemployed">
                      Unemployed : Employed
                    </ng-container>
                  </ng-container>
                  <ng-container *ngIf="!employed || !unemployed">
                    Employed : Unemployed
                  </ng-container>
                </div>
              </div>
              <div fxFlex="33" class="region-item">
                <div class="value">Professionals</div>
                <div class="title">Top Occupation Group</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </ng-container>
</div>
